import _ from "lodash";
import NEXUS_CONST from "./constants";
import CONFIG from "./config";
import * as utils from "./utils";

const nexusStore = new Map();

export const getSbgName = (id) => NEXUS_CONST.SBG_ICON_CLS[id];

export const getSbgNameTxt = (id) => NEXUS_CONST.SBG_LABEL_TXT[id];

export const getRandomNum = () => _.random(545, 745);

export const set = (k, d) => nexusStore.set(k, d);

export const get = (k) => nexusStore.get(k);

export const setLocal = (k, d) => localStorage.setItem(k, d);

export const getLocal = (k) => localStorage.getItem(k);

export const removeLocal = (k) => localStorage.removeItem(k);

export const clearLocal = () => localStorage.clear();

export const getSSOUrl = () => {
  return `${CONFIG.SSO_BASE_URL}${CONFIG.AUTH_URL}client_id=${CONFIG.CLIENT_ID}&response_type=${CONFIG.SSO_RESPONSE_TYPE}&scope=${CONFIG.SSO_SCOPE}&redirect_uri=${CONFIG.BASE_URL}${CONFIG.SSO_REDIRECT_URL}`;
};

export const getApps = (user) => {
  let apps = NEXUS_CONST.APPS_LIST_MEMBER;
  if (
    _.includes(user.roleType, "Owner") ||
    _.includes(user.roleType, "Alternate")
  ) {
    apps = NEXUS_CONST.APPS_LIST_OWNER;
  }
  return apps;
};

export const isSiteOwner = (user) => {
  return (
    _.includes(user.roleType, "Owner") || _.includes(user.roleType, "Alternate")
  );
};

const getRowLayout = () => {
  return {
    rowType: "",
    rowIndex: "",
    rowItems: [],
  };
};

export const getBasePath = () => window.location.origin;

export const getRowLayoutByType = (type) => {
  let layout = getRowLayout();
  layout.rowItems = _.fill(Array(type), []);
  layout.rowType = "col" + type;
  return layout;
};

export const isPrivateSite = (userData, siteInfo) => {
  let userID = siteInfo.users.findIndex((d) => d.employeeId == userData.hId);
  if (userData.roleType == "Owner") return false;
  if (userID > -1) return false;
  else return true;
};

export const WIDGETS = [
  { id: "tableau", label: "Tableau content", type: "tableau" },
  { id: "rail", label: "Action Rail", type: "system" },
  { id: "alertsMsgs", label: "Alerts", type: "system" },
  { id: "calendar", label: "Calendar", type: "system" },
  { id: "communication", label: "Communications/Recognition", type: "system" },
  { id: "costMetric", label: "Cost Metric: DLE", type: "system" },
  { id: "downtimeReason", label: "Downtime Reason", type: "system" },
  { id: "html", label: "Embed HTML code", type: "html" },
  { id: "gemba", label: "Tracker", type: "system" },
  { id: "hseCommunication", label: "HSE Communication", type: "system" },
  { id: "gembaTracking", label: "Gemba and MOC", type: "system" },
  { id: "qualityMetric", label: "Quality Metric: FPY", type: "system" },
  { id: "mocWidget", label: "Management of Change", type: "system" },
  // { id: "incidentWidget", label: "Incident", type: "system" },
  { id: "inlineFile", label: "Image/PDF", type: "inlineFile" },
  { id: "whiteboard", label: "Whiteboard", type: "whiteboard" },
  { id: "ophWidget", label: "OPH Tracker", type: "system" },
  { id: "rpsWidget", label: "Structured Problem Solving", type: "system" },
  { id: "sa3Widget", label: "Strategic A3", type: "system" },
  { id: "gembawalk", label: "Gemba Walk Priorities", type: "system" },
  {
    id: "deliveryMetric",
    label: "Delivery Metric : Schedule Attainment",
    type: "system",
  },
  {
    id: "deliveryMetricOPH",
    label: "Delivery Metric : OPH Attainment",
    type: "system",
  },
  {
    id: "multiSurveyWidget",
    label: "Survey App",
    type: "system",
  },
];

export const getWidgetTpl = (widget, title, description) => {
  let widgetInfo = WIDGETS[_.findIndex(WIDGETS, ["id", widget])];
  let widgetId = widgetInfo.id + "_" + getRandomNum();
  return {
    itemId: widgetInfo.id,
    type: widgetInfo.type,
    title: title,
    description: description,
    widgetId: widgetId,
    isActive: true,
  };
};

export const isUserSessExist = () => {
  const sessInfo = getLocal(NEXUS_CONST.LOCAL_SESSION);
  if (sessInfo != null) {
    const userInfo = dataDecode(sessInfo);
    let data = JSON.parse(userInfo);
    return data.isValid ? data : false;
  } else return false;
};

export const isRedirectURIExist = (pathname) => {
  const uriSessInfo = getLocal(NEXUS_CONST.REDIRECT_URI);
  return uriSessInfo != null
    ? uriSessInfo
    : setLocal(NEXUS_CONST.REDIRECT_URI, pathname);
};

export const defaultTemplate = () => {
  return [
    {
      id: "performance",
      title: "Performance",
      iconCls: "performance",
      rowIndex: 1,
      layout: [
        {
          rowType: "col1",
          rowIndex: 1,
          rowItems: [
            {
              itemId: "perfTableua",
              type: "",
              title: "Performance",
              description: "",
            },
          ],
        },
        {
          rowType: "col1",
          rowIndex: 2,
          rowItems: [
            {
              itemId: "perfRailGrid",
              name: "railGrid",
              description: "",
              title: "Performance grid",
            },
          ],
        },
      ],
    },
    {
      id: "safety",
      title: "Safety",
      iconCls: "safety",
      rowIndex: 2,
      layout: [
        {
          rowType: "col2",
          rowIndex: 1,
          rowItems: [
            {
              itemId: "safetyCross",
              type: "",
              title: "Safety cross",
              description: "",
            },
            {
              itemId: "gembaTracking",
              type: "",
              title: "Gemba tracking",
              description: "",
            },
          ],
        },
        // {
        //   rowType: "col2",
        //   rowIndex: 1,
        //   rowItems: [
        //     {
        //       itemId: "incident",
        //       type: "",
        //       title: "Incident",
        //       description: "",
        //     },
        //   ],
        // },
        {
          rowType: "col3",
          rowIndex: 1,
          rowItems: [
            {
              itemId: "managementofchange",
              type: "",
              title: "Management of Change",
              description: "",
            },
          ],
        },
        {
          rowType: "col1",
          rowIndex: 2,
          rowItems: [
            {
              itemId: "railGrid",
              name: "railGrid",
              description: "",
              title: "Safety grid",
            },
          ],
        },
      ],
    },
  ];
};

export const fileTypeInfo = (types) => (
  <span>
    Files (<b>{types.join(", ")}</b>) are allowed.
  </span>
);
export const getMetricData = (data) => {
  data.data["appId"] = NEXUS_CONST.APP_ID;
  data.data["username"] = get("username");
  return data;
};

export const STD_WORK_URL =
  "https://honeywellprod.sharepoint.com/teams/Nexus/Shared%20Documents/Forms/AllItems.aspx?csf=1&web=1&e=T9aZ0M&cid=a51e7660%2D1d5c%2D4642%2D90ba%2De652fcc8b0e3&RootFolder=%2Fteams%2FNexus%2FShared%20Documents%2FGeneral&FolderCTID=0x0120008753293FA364404CAF6B129A30AAC69B";

export const dataEncode = (a) => btoa(btoa(a + "_zQe"));

export const dataDecode = (a) => {
  try {
    let d = atob(atob(a)).split("_zQe");
    return d[0];
  } catch (e) {
    clearLocal();
    window.location.href = getSSOUrl();
  }
};

export const getUrlQueryData = () => {
  const urlSearchParams = new URLSearchParams(window.location.search);
  const urlParams = Object.fromEntries(urlSearchParams.entries());
  return urlParams;
};

export const tableuaTplInfo = (d, t, p) => {
  let data = d.replace("name='ticket'", "").replace('name="ticket"', "");
  if (!get("isAuthcomlpeted")) {
    set("isAuthcomlpeted", 1);
    data = data.replace(
      "</object>",
      "<param name='ticket' value='" + t + "' /></object>"
    );
  }
  if (p) {
    data = data.replace("</object>", p + "</object>");
  }
  return data;
};

export const userLogTpl = () => {
  return {
    event: "",
    data: {
      action: "",
      module: "",
      section: "",
    },
  };
};

export const SQDCP = [
  "Safety",
  "Quality",
  "Delivery",
  "Inventory",
  "Cost",
  "People",
];

export const isEditable = (user) => {
  return (
    _.includes(user.roleType, "Owner") ||
    _.includes(user.roleType, "Alternate") ||
    _.includes(user.roleType, "Member")
  );
};

export const TIER_LIST = [
  { id: "1", label: "Tier 1" },
  { id: "2", label: "Tier 2" },
  { id: "3", label: "Tier 3" },
  { id: "4", label: "Tier 4" },
  { id: "5", label: "Tier 5" },
  { id: "6", label: "Tier 6" },
  { id: "7", label: "Tier 7" },
  { id: "8", label: "Tier 8" },
];

export const SITE_TIER_LIST = [
  { id: "", label: "All Tiers" },
  { id: "1", label: "Tier 1" },
  { id: "2", label: "Tier 2" },
  { id: "3", label: "Tier 3" },
  { id: "4", label: "Tier 4" },
  { id: "5", label: "Tier 5" },
  { id: "6", label: "Tier 6" },
  { id: "7", label: "Tier 7" },
  { id: "8", label: "Tier 8" },
];

export const isEqual = (a, b) => _.isEqual(a, b);

export const openFileToView = (file, folder, subFolder) => {
  let addSubFolder = "";
  if (file.imageName) file = file.imageName;
  if (file.siteImage) file = file.siteImage;
  if (subFolder == "RootCauseAnalysis") {
    addSubFolder = "&subfolderName=RootCauseAnalysis";
  }
  if (subFolder == "Result") {
    addSubFolder = "&subfolderName=Result";
  }
  if (subFolder == "Breakdown") {
    addSubFolder = "&subfolderName=Breakdown";
  }
  if (subFolder == "Experiment") {
    addSubFolder = "&subfolderName=Experiment";
  }
  // The following code has been commented out as it was not part of MVO1 scope.
  /*window.open(
    CONFIG.API_ENDPOINT +
      `docviewer/Viewer?fileName=${encodeURIComponent(
        file
      )}&folderName=${folder}${addSubFolder}`,
    "_blank",
    "config='toolbar=no,title=Nexus, menubar=no,scrollbars=no,resizable=no,location=no,directories=no,status=no,width=" +
      900 +
      ",height=" +
      600 +
      ",top=" +
      500 +
      ",left=" +
      200 +
      "'"
  );*/
};

export const getTypeOfFile = (url, folder) => {
  switch (url.fileExtension?.toLowerCase()) {
    case "gif":
    case "png":
    case "jfif":
    case "jpg":
    case "jpeg":
      openFileToView(url, folder);
      break;
    case "ppt":
    case "pptx":
    case "pdf":
    case "excel":
    case "xlsx":
    case "csv":
    case "xls":
      openFileToView(url.imageName, folder, url.subfolderName);
      break;
    default:
      return { type: "image/jpg" };
  }
};

export const onDownloadFile = (fileName, folderName, subFolderName) => {
  let addSubFolder = "";
  if (subFolderName == "RootCauseAnalysis") {
    addSubFolder = "&subfolderName=RootCauseAnalysis";
  }
  if (subFolderName == "Result") {
    addSubFolder = "&subfolderName=Result";
  }
  if (subFolderName == "Breakdown") {
    addSubFolder = "&subfolderName=Breakdown";
  }
  if (subFolderName == "KPIInitialState") {
    addSubFolder = "&subfolderName=KPIInitialState";
  }
  if (subFolderName == "KPITargetState") {
    addSubFolder = "&subfolderName=KPITargetState";
  }

  if (subFolderName == "GapAnalysis") {
    addSubFolder = "&subfolderName=GapAnalysis";
  }
  if (subFolderName == "Experiment") {
    addSubFolder = "&subfolderName=Experiment";
  }
  if (subFolderName == "Results") {
    addSubFolder = "&subfolderName=Results";
  }

  var link = document.createElement("a");
  link.href =
    CONFIG.API_ENDPOINT +
    `api/Docviewer/DownloadFile?fileName=${encodeURIComponent(
      fileName
    )}&folderName=${folderName}${addSubFolder}`;
  link.download = fileName;

  // Adding Authorization header
  var headers = new Headers();

  // Construct the request
  var request = new Request(link.href, {
    method: "GET",
    headers: {
      "customer-id": utils.get("tenantId"),
      Accept: "application/json",
      Authorization: `Bearer ${utils.get("accessToken")}`,
    },
  });

  // Fetch the file
  fetch(request)
    .then((response) => response.blob())
    .then((blob) => {
      // Create a URL for the blob
      var url = window.URL.createObjectURL(blob);
      // Create a temporary link element
      var a = document.createElement("a");
      a.href = url;
      a.download = fileName;
      // Append the link to the DOM and click it
      document.body.appendChild(a);
      a.click();
      // Remove the temporary link
      window.URL.revokeObjectURL(url);
    })
    .catch((error) => {
      console.error("Error downloading file:", error);
    });
};

export const getUpdatedRecord = (oldData, newData) => {
  const newDataKeys = Object.keys(newData);
  const updatedObj = {};
  newDataKeys.map((key) => {
    updatedObj[key] = {
      oldV: oldData[key],
      newV: newData[key],
    };
  });
  return updatedObj;
};

export const saveUserPref = ({
  widgetId,
  siteId,
  tierId,
  moduleName,
  loggedinUser,
  prefSess,
  GRID_COLS,
}) => {
  let data = get("cols_" + widgetId);
  let colFil = get("colFil_" + widgetId);
  let userPref = get(prefSess);
  let info = {
    layoutID: 0,
    tierID: tierId,
    siteUID: siteId,
    widgetId: widgetId,
    module: moduleName,
  };

  if (data && data.length > 0) {
    info.filter = JSON.stringify(data);
    if (userPref && userPref.filter) {
      if (userPref.filter != info.filter) {
        info.layoutID = userPref.layoutID;
      }
    } else if (userPref && !userPref.filter && GRID_COLS != info.filter) {
      info.layoutID = 0;
    }
  }
  if (colFil && colFil.length > 0) {
    if (userPref && userPref.columnFilter != JSON.stringify(colFil)) {
      info.columnFilter = colFil ? JSON.stringify(colFil) : null;
    }
  }

  let columns = get(`colWidth_${widgetId}`);
  const newColumnWidths = {};
  if (columns) {
    columns.forEach((column) => {
      newColumnWidths[column.dataField] = column.width;
    });
    info.userID = loggedinUser;
    info.module = moduleName;
    info.layoutName = widgetId;
    info.layoutColumns = JSON.stringify(newColumnWidths);
    info.widgetId = widgetId;
  }
  return info;
};

export const applyUserPref = (dataGrid, userPrefSettings) => {
  let cols = dataGrid.current.instance.getVisibleColumns();
  let gridIns = dataGrid.current.instance;
  if (userPrefSettings && userPrefSettings.filter) {
    let saveCols = JSON.parse(userPrefSettings.filter);
    cols.pop();
    if (saveCols.length > 0) {
      cols.forEach((d) => {
        let isExist = saveCols.findIndex((v) => v == d.dataField);
        if (isExist > -1) {
          gridIns.columnOption(d.dataField, "visible", true);
        } else gridIns.columnOption(d.dataField, "visible", false);
      });
    }
  }
  if (userPrefSettings && userPrefSettings.columnFilter) {
    let colsFil = userPrefSettings.columnFilter
      ? JSON.parse(userPrefSettings.columnFilter)
      : [];
    cols.forEach((d) => {
      let colFils = colsFil.find((j) => j.id == d.dataField);
      if (colFils && "exclude" != colFils.filter && "include" != colFils.filter)
        gridIns.columnOption(d.dataField, "filterValues", colFils.filter);
      else if (colFils && "exclude" == colFils.filter)
        gridIns.columnOption(d.dataField, "filterType", colFils.filter);
      else gridIns.columnOption(d.dataField, "filterType", "exclude");
    });
  }
  if (
    userPrefSettings &&
    userPrefSettings.layoutColumns &&
    dataGrid !== null &&
    dataGrid.current !== null &&
    dataGrid.current.instance !== null
  ) {
    let cols = JSON.parse(userPrefSettings.layoutColumns);
    if (typeof cols === "object") {
      const dataGridInstance = dataGrid.current.instance;
      Object.entries(cols).forEach(([prop, value]) => {
        dataGridInstance.columnOption(prop, "width", value);
      });
      dataGrid.current.instance.resize();
    }
  }
};

export const setGridUserPrefs = (e, widgetId) => {
  var activeCols = e.component.getVisibleColumns();
  let cCnt = activeCols.length - 1;
  let col = [],
    colFil = [];
  for (let i = 0; i < cCnt; i++) {
    let filter = null;
    col.push(activeCols[i]["dataField"]);
    if (activeCols[i]["filterValues"]) filter = activeCols[i]["filterValues"];
    else if (activeCols[i]["filterValue"])
      filter = activeCols[i]["filterValue"];
    else if (activeCols[i]["filterType"]) filter = activeCols[i]["filterType"];
    if (filter)
      colFil.push({ id: [activeCols[i]["dataField"]], filter: filter });
  }
  set("cols_" + widgetId, col);
  set("colFil_" + widgetId, colFil);
  var columnChooserView = e.component.getView("columnChooserView");
  if (!columnChooserView._popupContainer) {
    columnChooserView._initializePopupContainer();
    columnChooserView.render();
    columnChooserView._popupContainer.option("position", {
      of: e.element,
      my: "right top",
      at: "right top",
      offset: "0 50",
    });
  }
};

export const setGridWidthPrefs = (e, widgetId) => {
  var activeCols = e.component.getVisibleColumns();
  set(`colWidth_${widgetId}`, activeCols);
};
